import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetFetchCurrentUser($id: ID!) {
    expert(id: $id) {
      id
      name
      email
      photoUrl
      isEmailVerified
      roles {
        id
        role
        partner {
          id
          name
          status
          settings {
            id
            appearance {
              chatWidgetPhotoUrl
            }
          }
        }
      }
      abilities
    }
  }
`);
